import { HttpMethod } from "../../enums/HttpMethod";
import { ApiResponseMessage } from "../../types/api/ApiResponses";
import { apiFetch } from "../helpers";

interface IApiEmail {
    Location: string;
    ClientName: string;
    GroupId: string;
    FamilyId?: number;
    Subject: string;
    Enquiry: string;
    Body: string;
    Email: string;
    Phone: string;
    ContactTime?: string;
}

export const sendContactEmail = async (email: IApiEmail): Promise<boolean> => {
    return apiFetch<ApiResponseMessage<boolean>>(`/api/v1/email/contact`, {
        method: HttpMethod.Post,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(email)
    }).then((res) => res.isSuccessful);
};

export const sendShareEmail = async (
    caseId: number,
    email: IApiEmail
): Promise<boolean> => {
    return apiFetch<ApiResponseMessage<boolean>>(`/api/v1/email/share/${caseId}`, {
        method: HttpMethod.Post,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(email)
    }).then((res) => res.isSuccessful);
};
